import React from 'react'
import { checkTextTranslation } from '../../utils/useful'

class TableRegionInput extends React.Component {
    state = {
    }

    componentDidMount() {
        // console.log('TableTextInput', this.props.data)
    }





    render() {
        // let styleInfo = this.props.styleInfo

        let text = ''
        // let images = [] 
        if (Array.isArray(this.props.data) && this.props.data.length > 0) {
            if (this.props.data.length > 1) {
                text = this.props.data.length + " countries"
            } else {
                if (this.props.data[0].states && this.props.data[0].states.length > 0) {
                    text = this.props.data[0].country?.name + " - " + this.props.data[0].states.length + ' regions'
                } else {
                    text = this.props.data[0].country?.name
                }
            }
        }

        return (
            <div className="w-100 h-100 flexcc">
                <p className="" style={{ textOverflow: 'ellipsis', overflow: 'hidden', width: '100%' }}>
                    {Array.isArray(this.props.data) && this.props.data.map((region, index) => {
                        return (
                            <span className='mrd-1'>{region.country?.emoji}</span>
                        )
                    })}
                    {text}</p>
            </div>
        )
    }
}

export default TableRegionInput;